<ng-container *ngIf="isUpgradeApiSubscribeRoute">
  <router-outlet></router-outlet>
</ng-container>
<ng-container *ngIf="!isUpgradeApiSubscribeRoute">
<ng-container *ngIf="isLoading; else content">
  <!-- Pantalla de carga -->
  <div class="loader-container">
    <div class="loader"></div> 
  </div>
</ng-container>
<ng-template #content>
<ng-container *ngIf="isScreenLarge; else mobileLayout">
  <mat-sidenav-container class="principal-container">

    <mat-sidenav-content style="height: 70px; background-color:#FFF8F1;">
      <mat-toolbar style="padding: 10px;">
        <div *ngIf="isLogin && isEVPFlag" (click)="selectMenuItem('summary')" style="background: url(./assets/images/text-inspector-logo.svg);
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              width: 170px;
              height: 50px;
              margin:  5px;
              margin-top: 15px; margin-right: 75px; margin-left: 10px; cursor: pointer;">
        </div>
        <div *ngIf="!isLogin || !isEVPFlag" (click)="selectMenuItem('summaryfree')" style="background: url(./assets/images/text-inspector-logo.svg);
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              width: 170px;
              height: 50px;
              margin:  5px;
              margin-top: 15px; margin-right: 75px; margin-left: 10px; cursor: pointer;">
        </div>
        <span class="spacer2"></span>
        <span *ngIf="isLogin && userObject!=null" style="font-size: 16px; font-weight: 300; /* Light */; font-family: 'Inter'; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Welcome to Text Inspector, {{userObject.user.first_name}}</span>
        <span *ngIf="!isLogin || userObject==null" style="font-size: 16px; font-weight: 300; /* Light */; font-family: 'Inter';">Welcome to Text Inspector</span>
        <span class="spacer"></span>
        <a *ngIf="isLogin"  mat-button class="toolbar_list" [disabled]="isCreatingProject || disableButtonOfTextbox" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)="isNewAnalysis()"><span class="toolbar_list">New Analysis</span></a>
         <a mat-button class="toolbar_list" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" href="https://textinspector.com/support-form/" target="_blank" rel="noopener noreferrer"><span
            class="toolbar_list">Report a bug</span></a>
        <a *ngIf="isLogin" mat-button  [disabled]="isCreatingProject || disableButtonOfTextbox" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)="selectMenuItem('dashboard')" [ngClass]="{'selected2': isSelected('dashboard')}"
          class="toolbar_list"><span class="toolbar_list">Dashboard</span></a>
        <a mat-button class="toolbar_list" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" href="https://textinspector.com/help/statistics-readability/" target="_blank" rel="noopener noreferrer"><span
            class="toolbar_list">Help</span></a>
            
        <span *ngIf="isLogin && userObject!=null" >
          <button mat-button [matMenuTriggerFor]="accountMenu" class="custom-button" [disabled]="isCreatingProject || disableButtonOfTextbox">
            <span class="button-content"
              style="padding: 1px;padding-left: 15px;padding-right: 10px; font-size: 14px; font-weight: normal;">
              Hi, {{userObject.user.first_name}}
              <mat-icon>expand_more</mat-icon>
            </span>
            <span class="button-content" *ngIf="userObject==null"
              style="padding: 1px;padding-left: 15px;padding-right: 10px; font-size: 14px; font-weight: normal;">
              Hi, User
              <mat-icon>expand_more</mat-icon>
            </span>
          </button>
          <mat-menu #accountMenu="matMenu" style="text-align: right;" xPosition="before">
            <button mat-menu-item class="special-item" style="text-align: right;" (click)="selectMenuItem('profile')"
              [ngClass]="{'selecte': isSelected('profile')}">Your account</button>
            <!-- <a mat-menu-item  href="https://textinspector.com/support-form/" target="_blank" rel="noopener noreferrer" class="special-item" style="text-align: right;" >Report a bug</a> -->
            <button mat-menu-item  class="special-item" style="text-align: right;" (click)="logOut()">Log out</button>
            
          </mat-menu>
        </span>
        <span *ngIf="!isLogin">
          <!-- <a href="https://textinspector.com/account/logoutv2"> -->
          <!-- <a href="https://textinspector.kinsta.cloud/wplogin"> -->
          <a [href]="loginUrl">
            <button  mat-button class="custom-button" (click)="clearSessionStorage()" [disabled]="isCreatingProject">
              <span class="button-content"
                style="padding: 4px;padding-left: 15px;padding-right: 10px; font-size: 14px; font-weight: normal;" >
                Login/Sign up
              </span>
            </button>
          </a>
        </span>
      </mat-toolbar>
    </mat-sidenav-content>

    <ng-container *ngIf="newAnalysis">
      <new-analysis></new-analysis>
    </ng-container>

    

    <mat-sidenav *ngIf="selectedMenuItem !== 'profile' && selectedMenuItem !== 'apiplan'" mode="side" opened>
      <div class="sidenav">
        <!-- <span *ngIf="isLogin && showBdelete" style="padding-left: 10px;">
          <button mat-button [matMenuTriggerFor]="fileMenu" class="custom-button">
            <span class="button-content" style="padding: 3px;padding-left: 15px;padding-right: 10px;">
              File
              <mat-icon>expand_more</mat-icon>
            </span>
          </button>
          <mat-menu #fileMenu="matMenu">
            <button mat-menu-item (click)="openSaveDialog() && messageSaveProject()">{{textFile}}</button>
            <button *ngIf="showBdelete" mat-menu-item (click)="deleteProject()">Clear From Servers</button>
          </mat-menu>
        </span> -->

         <!-- <span *ngIf="isLogin && showBdelete" style="padding-left: 10px;">
                  <button mat-button (click)="deleteProject()" class="custom-button" style="margin-top:10px ; ">
                    
                      <span class="button-content" style="padding: 3px;padding-left: 15px;padding-right: 10px;">Clone project</span>
                      
                    
                  </button>
                 
                </span> -->

         <span *ngIf="isLogin && showBdelete" style="padding-left: 10px;">
                  <button mat-button (click)="deleteProject()" [disabled]="isCreatingProject" class="custom-button" style="margin-top:10px ; " *ngIf="!loaderClearServers">
                    
                      <span class="button-content" style="padding: 6px;padding-left: 15px;padding-right: 10px;">Clear from servers</span>

                    
                  </button>

                   <button mat-button (click)="deleteProject()" [disabled]="isCreatingProject" class="custom-button" style="margin-top:10px ; " *ngIf="loaderClearServers">
                    
                      <span class="button-content" style="padding: 6px;padding-left: 0px;padding-right: 0px; width: 163.31px; justify-content: center;">
                       
                          <div class="loader-clear-servers"></div>
                       
                      </span>
                    
                  </button>
                 
        </span>

        <!-- <span *ngIf="!isLogin" style="padding-left: 10px;">
          <button mat-button [matMenuTriggerFor]="fileMenu" class="custom-button">
            <span class="button-content" style="padding: 3px;padding-left: 15px;padding-right: 10px;">
              File
              <mat-icon>expand_more</mat-icon>
            </span>
          </button>
          <mat-menu #fileMenu="matMenu">
            <button mat-menu-item (click)="openSaveDialog()">Quick Analysis</button>
          </mat-menu>
        </span> -->
        <!------------------->
        <!------------------->
        <!-----PESTAÑAS------>
        <!------------------->
        <!------------------->
        <!------------------->

        <mat-nav-list>
          <div style="height: 25px;"></div> <!--ESPACIO-->
          <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="selectMenuItem('summary')" [ngClass]="{'selected': isSelected('summary')}" class="tabs-left">
            <img [src]="getIconUrl('summary')" class="tab-icon" >
            <span class="nav_list">Summary</span>
          </a>

          <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (click)="selectMenuItem('summaryfree')" [ngClass]="{'selected': isSelected('summaryfree')}" class="tabs-left">
            <img [src]="getIconUrl('summaryfree')" class="tab-icon">
            <span class="nav_list">Summary</span>
          </a>

          <a *ngIf="isLogin" [disabled]="isCreatingProject" mat-list-item (click)="handleClick('statistics')" [ngClass]="{'selected': isSelected('statistics')}" class="tabs-left">
            <img [src]="getIconUrl('statistics')" class="tab-icon">
            <span class="nav_list">Statistics</span>
          </a>

          <a *ngIf="!isLogin" [disabled]="isCreatingProject" mat-list-item (click)="handleClick('statisticsfree')" [ngClass]="{'selected': isSelected('statisticsfree')}" class="tabs-left">
            <img [src]="getIconUrl('statisticsfree')" class="tab-icon">
            <span class="nav_list">Statistics</span>
          </a>

          <a *ngIf="isLogin" mat-list-item
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()" (click)="handleClick2('readability')"
            [ngClass]="{'selected': isSelected('readability')}"
            [disabled]="isCreatingProject || Disabled()" class="tabs-left">
            <img [src]="getIconUrl('readability')" class="tab-icon">
              <span class="nav_list">Readability</span>
          </a>

          <a *ngIf="!isLogin" mat-list-item (click)="handleClick('readabilityfree')"
            [ngClass]="{'selected': isSelected('readabilityfree')}"
            class="tabs-left" [disabled]="isCreatingProject">
            <img [src]="getIconUrl('readabilityfree')" class="tab-icon">
              <span class="nav_list">Readability</span>
          </a>

          <!-- MODAL API-->
          <div class="modal-backdrop" *ngIf="showPaymentModal">
            <div class="payment-modal">

              <button class="close-btn" (click)="closeModalApi()">✕</button>

              <div class="icon">
                <img class="icon-success" src="./assets/images/successful-icon.svg">
              </div>

              <h2 class="payment_title">- Payment Successful -</h2>

              <p class="payment_subtitle">
                Thank you for subscribing to Text Inspector API.<br />
                You can now access all the exclusive benefits and features.
              </p>
              <br>
              <br>
              <div class="actions">
                <button class="btn-success primary" (click)="goToDocs()">View API Docs</button>
                <button class="btn-success secondary" (click)="goToAccount()">Go To My Account</button>
              </div>

            </div>
          </div>


          <div *ngIf="showModal" class="modal">
            <p>Simple Mode not available for this tool</p>
          </div>

           <div *ngIf="valueLimitProjects" class="modal">
            <p>You have reached your project limit (10).</p>
          </div>

           <div *ngIf="valueLimitWords" class="modal">
            <p>You text exceeds the {{wordsLimit}} words limit.</p>
          </div>

          <div *ngIf="valueEditCategory" class="modal-1">
            <p>Save your changes before changing categories.</p>
            <!-- <pre>{{stringEditCategory}}</pre> respeta saltos de línea -->
          </div>





          <div *ngIf="valueM" class="modal">
            <p>The text is currently locked</p>
          </div>

          <div *ngIf="valueTM" class="modal">
            <p>Empty Text</p>
          </div>

          <!-- <div *ngIf="noProyectModal && isLogin" class="modal-export" style=" border: 1px solid #EE1A1A;">
            <div class="line" style="background-color: #EE1A1A;" ></div>
            <p>Project No Loaded</p>
          </div>

          <div *ngIf="loadProyectModal && isLogin" class="modal-export" style="border: 1px solid #217525;">
            <div class="line" style="background-color: #217525;"></div>
            <p>Project Loaded</p>
          </div> -->

          <div *ngIf="showModalExport" class="modal-export">
            <div class="line"></div>
            <p>Project No Loaded</p>
          </div>

          <div *ngIf="showModalExport2" class="modal-export-warning">
            <p>NOT ON THE MAIN PAGE</p>
          </div>

          <a *ngIf="isLogin" mat-list-item 
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"  
            (click)="handleClick2('errors')" [ngClass]="{'selected': isSelected('errors')}" [disabled]="Disabled() || isCreatingProject" class="tabs-left">
            <img [src]="getIconUrl('errors')" class="tab-icon">
            <span class="nav_list">Errors</span>
          </a>

          <a *ngIf="!isLogin" mat-list-item   
          (click)="handleClick('errorsfree')" [ngClass]="{'selected': isSelected('errorsfree')}"  class="tabs-left" [disabled]="isCreatingProject">
          <img [src]="getIconUrl('errorsfree')" class="tab-icon">
          <span class="nav_list">Errors</span>
        </a>

          <a *ngIf="isLogin" mat-list-item
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"  
            (click)="handleClick2('lexicalDiversity')"
            [ngClass]="{'selected': isSelected('lexicalDiversity')}" [disabled]="Disabled() || isCreatingProject" class="tabs-left">
            <img [src]="getIconUrl('lexicalDiversity')" class="tab-icon">
            <span class="nav_list">Lexical Diversity</span>
          </a>

          <a *ngIf="!isLogin" mat-list-item
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"  
            (click)="handleClick3('lexicalfree')"
            [ngClass]="{'selected': isSelected('lexicalfree')}"  class="tabs-left" [disabled]="isCreatingProject">
            <img [src]="getIconUrl('lexicalfree')" class="tab-icon">
            <span class="nav_list">Lexical Diversity</span>
          </a>

          <a *ngIf="isLogin" mat-list-item (click)="handleClick('tagger')" [ngClass]="{'selected': isSelected('tagger')}"
            class="nav-item" [disabled]="isCreatingProject">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('tagger')" class="tab-icon">
                <span class="nav_list">Tagger</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'tagger'">
                <div>
                  <img style="margin-left: 60px;" src="./assets/images/hard-metric-icon.svg"><span
                    style="color:#FA7575;">Hard</span>
                </div> 
              </ng-container>
              <ng-container *ngIf="selectedMenuItem !== 'tagger'">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div> 

              </ng-container> -->
            </div>
          </a>

          <a *ngIf="!isLogin" mat-list-item (click)="handleClick('taggerfree')" [ngClass]="{'selected': isSelected('taggerfree')}"
            class="nav-item" [disabled]="isCreatingProject">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('taggerfree')" class="tab-icon">
                <span class="nav_list">Tagger</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'taggerfree'">
                <div>
                  <img style="margin-left: 60px;" src="./assets/images/hard-metric-icon.svg"><span
                    style="color:#FA7575;">Hard</span>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem !== 'taggerfree'">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>

              </ng-container> -->
            </div>
          </a>

          <div style="width:auto ;height: 5px;align-items: center; padding-left: 20px;  padding-right: 20px;">
            <div style="width:auto ;height: .5px; background-color: #F3F3F5;  "></div>
          </div>

          <a mat-list-item class="tabs-left" [disabled]="isCreatingProject">
            <span class="nav_list">Lexis</span>
          </a>

          <a *ngIf="isLogin && isEVPFlag" mat-list-item 
           (click)="handleClick('evp')" [ngClass]="{'selected': isSelected('evp')}" class="tabs-left" [disabled]="isCreatingProject">
            <div style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('evp')" class="tab-icon" style="padding-left: 15px ">
                <span class="nav_list">EVP</span>
              </div>
            </div>
          </a>

          <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (click)="handleClick('evpfree')" [ngClass]="{'selected': isSelected('evpfree')}" class="tabs-left" [disabled]="isCreatingProject">
            <div style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('evpfree')" class="tab-icon" style="padding-left: 15px ">
                <span class="nav_list">EVP</span>
              </div>
              <div >
                <img (mouseenter)="openTooltipModal($event)" 
                (mouseleave)="closeTooltipModal()" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('evpfree')">
              </div> 
            </div>
          </a>

          <a *ngIf="isLogin" mat-list-item (click)="handleClick('kvl')" [ngClass]="{'selected': isSelected('kvl')}" class="tabs-left" [disabled]="isCreatingProject">
            <img [src]="getIconUrl('kvl')" class="tab-icon" style="padding-left: 15px ">
            <span class="nav_list">KVL</span>
          </a>

          <a *ngIf="!isLogin" mat-list-item (click)="handleClick('kvlfree')" [ngClass]="{'selected': isSelected('kvlfree')}" class="tabs-left" [disabled]="isCreatingProject">
            <img [src]="getIconUrl('kvlfree')" class="tab-icon" style="padding-left: 15px ">
            <span class="nav_list">KVL</span>
          </a>

          <a *ngIf="isLogin" mat-list-item (click)="handleClick('coca')" [ngClass]="{'selected': isSelected('coca')}" [disabled]="isCreatingProject"
            class="nav-item">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('coca')" class="tab-icon" style="padding-left: 15px ">
                <span class="nav_list">{{ getCocaText() }}</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'coca'">
                <div>
                  <img style="margin-left: 52px;" src="./assets/images/hard-metric-icon.svg"><span
                    style="color:#FA7575;">Hard</span>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem !== 'coca'">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>

              </ng-container> -->
            </div>
          </a>

          <a *ngIf="!isLogin" mat-list-item (click)="handleClick('cocafree')" [ngClass]="{'selected': isSelected('cocafree')}" [disabled]="isCreatingProject"
            class="nav-item">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('cocafree')" class="tab-icon" style="padding-left: 15px ">
                <span class="nav_list">{{ getCocaText() }}</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'cocafree'">
                <div>
                  <img style="margin-left: 52px;" src="./assets/images/hard-metric-icon.svg"><span
                    style="color:#FA7575;">Hard</span>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem !== 'cocafree'">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>

              </ng-container> -->
            </div>
          </a>

          <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="handleClick('awl')" [ngClass]="{'selected': isSelected('awl')}" class="nav-item" [disabled]="isCreatingProject">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('awl')" class="tab-icon" style="padding-left: 15px">
                <span class="nav_list">AWL</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'awl'">
                <div>
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem !== 'awl'">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>
              </ng-container> -->
            </div>
          </a>

          <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (click)="handleClick('awlfree')" [ngClass]="{'selected': isSelected('awlfree')}" class="nav-item" [disabled]="isCreatingProject">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('awlfree')" class="tab-icon" style="padding-left: 15px">
                <span class="nav_list">AWL</span>
              </div>
              <div>
                <img (mouseenter)="openTooltipModal($event)" 
                (mouseleave)="closeTooltipModal()" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('awlfree')">
              </div> 
            </div>
          </a>

          <div style="width:auto ;height: 5px;align-items: center; padding-left: 20px;  padding-right: 20px;">
            <div style="width:auto ;height: .5px; background-color: #F3F3F5;  "></div>
          </div>

          <a *ngIf="isLogin && isEVPFlag" mat-list-item 
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"
            (click)="handleClick2('metadiscourse')"
            [ngClass]="{'selected': isSelected('metadiscourse')}" [disabled]="Disabled() || isCreatingProject" class="nav-item">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('metadiscourse')" class="tab-icon">
                <span class="nav_list">Metadiscourse</span>
              </div>
              <!-- <ng-container *ngIf="selectedMenuItem === 'metadiscourse'">
                <div>
                  <img style="margin-left: 1px;" src="./assets/images/hard-metric-icon.svg"><span
                    style="color:#FA7575;">Hard</span>
                </div>
              </ng-container>
              <ng-container *ngIf="checked && (selectedMenuItem !== 'metadiscourse')">
                <div class="hover-content">
                  <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                </div>
              </ng-container> -->
            </div>
          </a>

          <a *ngIf="!isLogin || !isEVPFlag"  (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"  mat-list-item (click)="handleClick3('metadiscoursefree')"
          [ngClass]="{'selected': isSelected('metadiscoursefree')}"  class="nav-item" [disabled]="isCreatingProject">
            <div
              style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('metadiscoursefree')" class="tab-icon">
                <span class="nav_list">Metadiscourse</span>
              </div>
              <div>
                <img (mouseenter)="openTooltipModal($event)" 
                (mouseleave)="closeTooltipModal()" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('metadiscoursefree')">
              </div> 
            </div>
          </a>

          <a *ngIf="isLogin && isEVPFlag" mat-list-item 
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"
            (click)="handleClick2('scorecard')"
            [ngClass]="{'selected': isSelected('scorecard')}" [disabled]="Disabled() || isCreatingProject" class="tabs-left">
            <div style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('scorecard')" class="tab-icon">
                <span class="nav_list" style="font-weight: 600;">SCORECARD</span>
              </div>
            </div>
          </a>

          <a *ngIf="!isLogin || !isEVPFlag"   (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()" mat-list-item  (click)="handleClick3('scorecardfree')"
          [ngClass]="{'selected': isSelected('scorecardfree')}" [disabled]="isCreatingProject" class="tabs-left">
            <div style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
              <div>
                <img [src]="getIconUrl('scorecardfree')" class="tab-icon">
                <span class="nav_list" style="font-weight: 600;">SCORECARD</span>
              </div>
              <div>
                <img (mouseenter)="openTooltipModal($event)" 
                (mouseleave)="closeTooltipModal()" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('scorecardfree')">
              </div> 
            </div>
          </a>

          <div style="height: 35px;"></div> <!--ESPACIO-->

          <div *ngIf="isLogin && textUID && isEVPFlag" style="text-align: center;  align-items: center; width: auto; margin-left: 9px;" >
            <button mat-button (click)="openGlobalExportDialog()" [disabled]="isCreatingProject" class="export-button"><span class="main-box-title-16" style="font-weight: 600;">Export Results</span> </button>
          </div>

          <div *ngIf="!isLogin || !isEVPFlag" style="text-align: center;  align-items: center; width: auto; margin-left: 9px; ">
            <button mat-button class="export-button" [disabled]="isCreatingProject">
              <div style="display: flex; align-items: center; text-align: center;">
                <div><img style=" padding-top: 2px; width: 18px; height: 18px; margin-right: 6px;" src="./assets/images/black_icons/blocked-icon.svg"></div> 
                <span class="main-box-title-16" style="font-weight: 600;">Export Results</span> 
              </div>
            </button>
          </div>

        </mat-nav-list>
  
        <div style="position: relative; display: flex; justify-content: center; top: 50px; color: #ffffff2b;">
          {{version}}
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content stle *ngIf="selectedMenuItem !== 'profile' && selectedMenuItem !== 'apiplan'" style="background-color: #FFF8F1;">
      <div class="content">
        <ng-container *ngIf="selectedMenuItem === 'dashboard'">
          <div class="full-panel">
            <dashboard></dashboard>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedMenuItem !== 'dashboard' ">
          <div *ngIf="isLogin" class="left-panel">
            <text-box [disabled]="isTextBoxDisabled" [textInputDisabled]="isTextInputDisabled" [checked]="checked"
              (checkedChange)="onCheckedChange($event)"></text-box>
          </div>
          <div *ngIf="!isLogin" class="left-panel">
            <text-box-free [isLogin]="isLogin" [disabled]="isTextBoxDisabled" [textInputDisabled]="isTextInputDisabled" [checked]="checked"
              (checkedChange)="onCheckedChange($event)"></text-box-free>
          </div>
          <div class="right-panel">
            <ng-container *ngIf="selectedMenuItem === 'summary'">
              <summary (menuItemSelected)="selectMenuItem($event)"></summary>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'statistics'">
              <statistics [checked]="checked"></statistics>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'readability'">
              <readability></readability>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'errors'">
              <errors></errors>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'lexicalDiversity'">
              <lexical-diversity></lexical-diversity>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'tagger'">
              <tagger [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></tagger>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'kvl'">
              <kvl [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></kvl>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'evp'">
              <evp [checked]="checked"></evp>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'coca'">
              <coca [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></coca>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'awl'">
              <awl [checked]="checked"></awl>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'metadiscourse'">
              <metadiscourse></metadiscourse>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'scorecard'">
              <scorecard></scorecard>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'summaryfree'">
              <summary-free (menuItemSelected)="selectMenuItem($event)"></summary-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'statisticsfree'">
              <statistics-free></statistics-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'readabilityfree'">
              <readability-free></readability-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'errorsfree'">
              <errors-free></errors-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'lexicalfree'">
              <lexical-free></lexical-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'taggerfree'">
              <tagger-free  (textItemSelected)="ontextItemSelected($event)"></tagger-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'evpfree'">
              <evp-free></evp-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'kvlfree'">
              <kvl-free  (textItemSelected)="ontextItemSelected($event)"></kvl-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'cocafree'">
              <coca-free  (textItemSelected)="ontextItemSelected($event)"></coca-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'awlfree'">
              <awl-free></awl-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'metadiscoursefree'">
              <metadiscourse-free></metadiscourse-free>
            </ng-container>
            <ng-container *ngIf="selectedMenuItem === 'scorecardfree'">
              <scorecard-free></scorecard-free>
            </ng-container>
          </div>
        </ng-container>
      </div>

    </mat-sidenav-content>
    <!-- Mostrar solo cuando selectedMenuItem es 'profile' -->

    <mat-sidenav-content *ngIf="selectedMenuItem === 'profile'" style="width: 100%;">
      <div class="full-screen-profile">
        <profile></profile>
      </div>
      <div *ngIf="valueLimitProfileUsers" class="modal">
        <p>You have reached your user limit (10).</p>
    </div>
    <div *ngIf="valueMessageProfileOrg" style="color: #EE1A1A; text-align: center;" class="modal">
        <p>{{messageProfileOrg}}</p>
    </div>
    
    
    
    </mat-sidenav-content>
    <mat-sidenav-content *ngIf="selectedMenuItem === 'apiplan'" style="width: 100%;">
      <div class="full-screen-profile">
        <api-update></api-update>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</ng-container>



<!------------------------------>
<!------------------------------>
<!------------------------------>
<!------------------------------>
<!------------------------------>
<!------------------------------>
<!------------------------------>

<ng-template #mobileLayout>
  <mat-sidenav-container class="principal-container">
    <ng-container *ngIf="newAnalysis">
      <new-analysis></new-analysis>
    </ng-container>
    <mat-sidenav-content *ngIf="!showContent" style="height: 70px; background-color:#FFF8F1;">

      <mat-toolbar style="padding: 10px;">
        <button mat-icon-button (click)="toggleContent()" [disabled]="isCreatingProject">
          <mat-icon style="text-align: left;">menu</mat-icon>
        </button>
        <div class="div_top_textinspector">
          <div *ngIf="isLogin && isEVPFlag" (click)="selectMenuItem('summary')" style="background: url(./assets/images/text-inspector-logo.svg);
                      background-position: center;
                      background-repeat: no-repeat;
                      background-size: contain;
                      width: 180px;
                      height: 50px;margin:  5px;
                      margin-top: 15px; margin-right: 42px;">
          </div>
          <div *ngIf="!isLogin || !isEVPFlag" (click)="selectMenuItem('summaryfree')" style="background: url(./assets/images/text-inspector-logo.svg);
                      background-position: center;
                      background-repeat: no-repeat;
                      background-size: contain;
                      width: 180px;
                      height: 50px;margin:  5px;
                      margin-top: 15px; margin-right: 42px;">
          </div>
        </div>
      </mat-toolbar>
    </mat-sidenav-content>

    <ng-container *ngIf="isExpandedDialog">
      <new-analysis></new-analysis>
    </ng-container>

    


    <mat-sidenav-content  style="background-color: #FFF8F1;">
      <div class="content">
        <ng-container *ngIf="showContent">
          <div class="full-panel-sidenav">
            <div class="mat-sidenav-example">
              <div class="div_username">
                <span *ngIf="isLogin" id="title_username">Welcome to Text Inspector, {{userObject.user.first_name}}</span>
                
                <span *ngIf="!isLogin" id="title_username">Welcome to Text Inspector</span>
                <button style="margin-right: 10px;" mat-icon-button (click)="toggleContent()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div id="top_tabs">
                <span *ngIf="isLogin && userObject!=null">
                  <button mat-button [matMenuTriggerFor]="accountMenu" class="custom-button" [disabled]="isCreatingProject || disableButtonOfTextbox">
                    <span class="button-content" *ngIf="userObject"
                      style="padding: 1px;padding-left: 15px;padding-right: 10px; font-size: 14px; font-weight: normal;">
                      Hi, {{userObject.user.first_name}}
                      <mat-icon>expand_more</mat-icon>
                    </span>
                  </button>
                  <mat-menu  #accountMenu="matMenu" style="text-align: right;" xPosition="after">
                    <button mat-menu-item style="text-align: right;"
                      (click)="selectMenuItem('profile') ;"
                      [ngClass]="{'selecte': isSelected('profile')}">Your account</button>
                    <!-- <a mat-menu-item  href="https://textinspector.com/support-form/" target="_blank" rel="noopener noreferrer" style="text-align: right;" >Support</a> -->
                    <button mat-menu-item style="text-align: right;" (click)="logOut()">Log out</button>
                    
                  </mat-menu>
                </span>
                <span *ngIf="!isLogin">
                  <a [href]="loginUrl">
                    <button mat-button class="custom-button" [disabled]="isCreatingProject" (click)="clearSessionStorage()">
                      <span class="button-content"
                        style="padding: 4px;padding-left: 15px;padding-right: 10px; font-size: 14px; font-weight: normal;">
                        Login/Sign up
                      </span>
                    </button>
                  </a>
                </span>
                
                <div *ngIf="isLogin" style="width: 60%; text-align: right;">
                  <a mat-button class="toolbar_list" [disabled]="isCreatingProject || disableButtonOfTextbox" (click)="isNewAnalysis()"><span class="toolbar_list">New Analysis</span></a>
                  <a mat-button class="toolbar_list" href="https://textinspector.com/support-form/" target="_blank" rel="noopener noreferrer"><span
                      class="toolbar_list">Report a bug</span></a>
                  <a mat-button [disabled]="isCreatingProject || disableButtonOfTextbox" (click)="selectMenuItem('dashboard')"
                    [ngClass]="{'selected2': isSelected('dashboard')}" class="toolbar_list"><span
                      class="toolbar_list">Dashboard</span></a>
                  <a mat-button class="toolbar_list" href="https://textinspector.com/help/statistics-readability/" target="_blank" rel="noopener noreferrer"><span
                      class="toolbar_list">Help</span></a>
                </div>
                <div *ngIf="!isLogin" style="width: 60%; text-align: right;">
                  <a mat-button class="toolbar_list" href="https://textinspector.com/support-form/" target="_blank" rel="noopener noreferrer"><span
                      class="toolbar_list">Report a bug</span></a>
                  <a mat-button class="toolbar_list" href="https://textinspector.com/help/statistics-readability/" target="_blank" rel="noopener noreferrer"><span
                      class="toolbar_list">Help</span></a>
                </div>
              </div>


              <div style="width:auto ;height: 5px;align-items: center; ">
                <div style="width:auto ;height: .5px; background-color: #F3F3F5;  "></div>
              </div>

              <div class="sidenav">
                <!-- <span *ngIf="isLogin && showBdelete">
                  <button mat-button [matMenuTriggerFor]="fileMenu" class="custom-button" style="margin-top:20px ; ">
                    <span class="button-content" style="padding: 3px;padding-left: 15px;padding-right: 10px; justify-content: space-between; width: 105px;">
                      <span>File</span>
                      <mat-icon>expand_more</mat-icon>
                    </span>
                  </button>
                  <mat-menu #fileMenu="matMenu">
                    <button mat-menu-item (click)="openSaveDialog() && messageSaveProject()">{{textFile}}</button>
                    <button *ngIf="showBdelete" mat-menu-item (click)="deleteProject()">Clear From Servers</button>
                  </mat-menu>
                </span> -->
               <span *ngIf="isLogin && showBdelete" style="padding-left: 10px;">
                  <button mat-button (click)="deleteProject()" class="custom-button" style="margin-top:10px ; " [disabled]="isCreatingProject" *ngIf="!loaderClearServers">
                    
                      <span class="button-content" style="padding: 6px;padding-left: 15px;padding-right: 10px;">Clear from servers</span>
                      
                    
                  </button>
                
                  <button mat-button (click)="deleteProject()" [disabled]="isCreatingProject" class="custom-button" style="margin-top:10px ; " *ngIf="loaderClearServers">
                  
                    <span class="button-content" style="padding: 6px;padding-left: 0px;padding-right: 0px; width: 163.31px; justify-content: center;">
                      
                        <div class="loader-clear-servers"></div>
                      
                    </span>
                    
                  </button>
                </span>
                <!-- <span *ngIf="!isLogin">
                  <button mat-button [matMenuTriggerFor]="fileMenu" class="custom-button" style="margin-top:20px ; ">
                    <span class="button-content" style="padding: 3px;padding-left: 15px;padding-right: 10px; justify-content: space-between; width: 105px;">
                      <span>File</span>
                      <mat-icon>expand_more</mat-icon>
                    </span>
                  </button>
                  <mat-menu #fileMenu="matMenu">
                    <button mat-menu-item (click)="openSaveDialog()">Quick Analysis</button>
                  </mat-menu>
                </span> -->
                <!------------------->
                <!------------------->
                <!-----PESTAÑAS------>
                <!------------------->
                <!------------------->
                <!------------------->

                <mat-nav-list>
                  <div style="height: 25px;"></div> <!--ESPACIO-->
                  <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="selectMenuItem('summary');" [ngClass]="{'selected': isSelected('summary')}" class="tabs-left">
                    <img [src]="getIconUrl('summary')" class="tab-icon">
                    <span class="nav_list">Summary</span>
                  </a>

                  <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (click)="selectMenuItem('summaryfree'); " [ngClass]="{'selected': isSelected('summaryfree')}" class="tabs-left">
                    <img [src]="getIconUrl('summaryfree')" class="tab-icon">
                    <span class="nav_list">Summary</span>
                  </a>
                  
                  <a *ngIf="isLogin" mat-list-item (click)="selectMenuItem('statistics'); " [disabled]="isCreatingProject"
                    [ngClass]="{'selected': isSelected('statistics')}" class="tabs-left">
                    <img [src]="getIconUrl('statistics')" class="tab-icon">
                    <span class="nav_list">Statistics</span>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="selectMenuItem('statisticsfree'); " [disabled]="isCreatingProject"
                    [ngClass]="{'selected': isSelected('statisticsfree')}" class="tabs-left">
                    <img [src]="getIconUrl('statisticsfree')" class="tab-icon">
                    <span class="nav_list">Statistics</span>
                  </a>

                  <a *ngIf="isLogin" mat-list-item (click)="checkedActionRea();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('readability')}" [disabled]="Disabled() || isCreatingProject" class="tabs-left">
                    <img [src]="getIconUrl('readability')" class="tab-icon">
                    <span class="nav_list">Readability</span>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="checkedActionReafree();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('readabilityfree')}" [disabled]="Disabled() || isCreatingProject" class="tabs-left">
                    <img [src]="getIconUrl('readabilityfree')" class="tab-icon">
                    <span class="nav_list">Readability</span>
                  </a>





                  <div *ngIf="showModalExportMobile" class="modal-export-mobile">
                    <p>NO PROJECT LOADED</p>
                  </div>
        
                  <div *ngIf="showModalExportMobile2" class="modal-export-mobile-warning">
                    <p>NOT ON THE MAIN PAGE</p>
                  </div>

                  <a *ngIf="isLogin" mat-list-item (click)="checkedActionErrors();onTabClickMobile()" [ngClass]="{'selected': isSelected('errors')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <img [src]="getIconUrl('errors')" class="tab-icon">
                    <span class="nav_list">Errors</span>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="checkedActionErrorsfree();onTabClickMobile()" [ngClass]="{'selected': isSelected('errorsfree')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <img [src]="getIconUrl('errorsfree')" class="tab-icon">
                    <span class="nav_list">Errors</span>
                  </a>

                  <a *ngIf="isLogin" mat-list-item (click)="checkedActionLexical();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('lexicalDiversity')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <img [src]="getIconUrl('lexicalDiversity')" class="tab-icon">
                    <span class="nav_list">Lexical Diversity</span>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="checkedActionLexicalfree();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('lexicalfree')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <img [src]="getIconUrl('lexicalfree')" class="tab-icon">
                    <span class="nav_list">Lexical Diversity</span>
                  </a>

                  <a *ngIf="isLogin" mat-list-item (click)="selectMenuItem('tagger'); " [ngClass]="{'selected': isSelected('tagger')}" [disabled]="isCreatingProject" 
                    class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('tagger')" class="tab-icon">
                        <span class="nav_list">Tagger</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'tagger'">
                        <div>
                          <img style="margin-left: 60px;" src="./assets/images/hard-metric-icon.svg"><span
                            style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="selectedMenuItem !== 'tagger'">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="selectMenuItem('taggerfree'); " [ngClass]="{'selected': isSelected('taggerfree')}" [disabled]="isCreatingProject" 
                    class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('taggerfree')" class="tab-icon">
                        <span class="nav_list">Tagger</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'taggerfree'">
                        <div>
                          <img style="margin-left: 60px;" src="./assets/images/hard-metric-icon.svg"><span
                            style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="selectedMenuItem !== 'taggerfree'">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <div style="width:auto ;height: 5px;align-items: center; padding-left: 20px;  padding-right: 20px;">
                    <div style="width:auto ;height: .5px; background-color: #F3F3F5;  "></div>
                  </div>

                  <a mat-list-item [disabled]="isCreatingProject" >
                    <span class="nav_list">Lexis</span>
                  </a>

                  <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="selectMenuItem('evp'); " [ngClass]="{'selected': isSelected('evp')}" class="tabs-left" [disabled]="isCreatingProject" > 
                    <img [src]="getIconUrl('evp')" class="tab-icon" style="padding-left: 15px ">
                    <span class="nav_list">EVP</span>
                  </a>

                  <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (click)="selectMenuItem('evpfree'); " [ngClass]="{'selected': isSelected('evpfree')}" class="tabs-left" [disabled]="isCreatingProject" >
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('evpfree')" class="tab-icon" style="padding-left: 15px ">
                        <span class="nav_list">EVP</span>
                      </div>
                      <div >
                        <img (click)="openTooltipModalMobile($event)" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('evpfree')">
                      </div> 
                    </div>
                  </a>

                  <a *ngIf="isLogin" mat-list-item (click)="selectMenuItem('kvl'); " [ngClass]="{'selected': isSelected('kvl')}" class="tabs-left" [disabled]="isCreatingProject" >
                    <img [src]="getIconUrl('kvl')" class="tab-icon" style="padding-left: 15px ">
                    <span class="nav_list">KVL</span>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="selectMenuItem('kvlfree'); " [ngClass]="{'selected': isSelected('kvlfree')}" class="tabs-left" [disabled]="isCreatingProject" >
                    <img [src]="getIconUrl('kvlfree')" class="tab-icon" style="padding-left: 15px ">
                    <span class="nav_list">KVL</span>
                  </a>

                  <a *ngIf="isLogin" mat-list-item (click)="selectMenuItem('coca'); " [ngClass]="{'selected': isSelected('coca')}" [disabled]="isCreatingProject" 
                    class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('coca')" class="tab-icon" style="padding-left: 15px ">
                        <span class="nav_list">{{getCocaText()}}</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'coca'">
                        <div>
                          <img style="margin-left: 52px;" src="./assets/images/hard-metric-icon.svg"><span
                            style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="selectedMenuItem !== 'coca'">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <a *ngIf="!isLogin" mat-list-item (click)="selectMenuItem('cocafree'); " [ngClass]="{'selected': isSelected('cocafree')}" [disabled]="isCreatingProject" 
                    class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('cocafree')" class="tab-icon" style="padding-left: 15px ">
                        <span class="nav_list">{{getCocaText()}}</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'cocafree'">
                        <div>
                          <img style="margin-left: 52px;" src="./assets/images/hard-metric-icon.svg"><span
                            style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="selectedMenuItem !== 'cocafree'">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <a *ngIf="isLogin"  mat-list-item (click)="selectMenuItem('awl'); " [ngClass]="{'selected': isSelected('awl')}" [disabled]="isCreatingProject" 
                    class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('awl')" class="tab-icon" style="padding-left: 15px">
                        <span class="nav_list">AWL</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'awl'">
                        <div>
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="selectedMenuItem !== 'awl'">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <a *ngIf="!isLogin"  mat-list-item (click)="selectMenuItem('awlfree'); " [ngClass]="{'selected': isSelected('awlfree')}" [disabled]="isCreatingProject" 
                  class="nav-item">
                  <div
                    style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                    <div>
                      <img [src]="getIconUrl('awlfree')" class="tab-icon" style="padding-left: 15px">
                      <span class="nav_list">AWL</span>
                    </div>
                    <div>
                      <img (click)="openTooltipModalMobile($event)" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('awlfree')">
                    </div> 
                  </div>
                </a>

                  <div style="width:auto ;height: 5px;align-items: center; padding-left: 20px;  padding-right: 20px;">
                    <div style="width:auto ;height: .5px; background-color: #F3F3F5;  "></div>
                  </div>

                  <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="checkedActionMeta();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('metadiscourse')}" [disabled]="Disabled() || isCreatingProject"  class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('metadiscourse')" class="tab-icon">
                        <span class="nav_list">Metadiscourse</span>
                      </div>
                      <!-- <ng-container *ngIf="selectedMenuItem === 'metadiscourse'">
                        <div>
                          <img style="margin-left: 1px;" src="./assets/images/hard-metric-icon.svg"><span
                            style="color:#FA7575;">Hard</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="checked && (selectedMenuItem !== 'metadiscourse')">
                        <div class="hover-content">
                          <img src="./assets/images/hard-metric-icon.svg"><span style="color:#FA7575;">Hard</span>
                        </div>

                      </ng-container> -->
                    </div>
                  </a>

                  <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (mouseenter)="onMouseEnter()"
                  (mouseleave)="onMouseLeave()" (click)="checkedActionMetafree();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('metadiscoursefree')}" [disabled]="Disabled() || isCreatingProject"  class="nav-item">
                    <div
                      style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('metadiscoursefree')" class="tab-icon">
                        <span class="nav_list">Metadiscourse</span>
                      </div>
                      <div>
                        <img (click)="openTooltipModalMobile($event)" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('metadiscoursefree')">
                      </div> 
                    </div>
                  </a>

                  <a *ngIf="isLogin && isEVPFlag" mat-list-item (click)="checkedActionScore();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('scorecard')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <img [src]="getIconUrl('scorecard')" class="tab-icon">
                    <span class="nav_list" style="font-weight: 600;">SCORECARD</span>
                  </a>

                  <a *ngIf="!isLogin || !isEVPFlag" mat-list-item (mouseenter)="onMouseEnter()"
                  (mouseleave)="onMouseLeave()" (click)="checkedActionScorefree();onTabClickMobile()"
                    [ngClass]="{'selected': isSelected('scorecardfree')}" [disabled]="Disabled() || isCreatingProject"  class="tabs-left">
                    <div
                    style="width: auto; justify-content: space-between; text-align: center;display: flex; align-items: center;">
                      <div>
                        <img [src]="getIconUrl('scorecardfree')" class="tab-icon">
                        <span class="nav_list" style="font-weight: 600;">SCORECARD</span>
                      </div>
                      <div>
                        <img (click)="openTooltipModalMobile($event)" style=" padding-top: 5px; width: 18px; height: 18px;" [src]="getIconUrlBlocked('scorecardfree')">
                      </div> 
                    </div>
                  </a>

                  <div style="height: 35px;"></div> <!--ESPACIO-->

                  <div *ngIf="(isLogin && textUID) && isEVPFlag" style="text-align: center;  align-items: center; width: auto; padding-left: 18%; padding-right: 18%;">
                    <button mat-button (click)="openGlobalExportDialog()" [disabled]="isCreatingProject"  class="export-button"><span class="main-box-title-16"
                        style="font-weight: 600;">Export Results</span> </button>
                  </div>

                  <div *ngIf="!isLogin || !isEVPFlag" style="text-align: center;  align-items: center; width: auto; padding-left: 18%; padding-right: 18%;">
                    <button mat-button class="export-button" [disabled]="isCreatingProject" >
                      <div style="display: flex; align-items: center; text-align: center;">
                        <div><img style=" padding-top: 2px; width: 18px; height: 18px; margin-right: 6px;" src="./assets/images/black_icons/blocked-icon.svg"></div> 
                        <span class="main-box-title-16" style="font-weight: 600;">Export Results</span> 
                      </div>
                      </button>
                  </div>
                  <br>
                  <br>
                </mat-nav-list>
                        <div style="position: relative; display: flex; justify-content: center; top: 50px; color: #ffffff2b;">
                    {{version}}
                  </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container>
          <div *ngIf="valueM" class="modal">
            <p>The text is currently locked</p>
          </div>
          <div *ngIf="valueTM" class="modal">
            <p>Empty Text</p>
          </div>
          <div *ngIf="valueLimitWords" class="modal2">
            <p>You text exceeds the {{wordsLimit}} words limit.</p>
          </div>

          
          <div *ngIf="valueEditCategory" class="modal2-1">
            <p>Save your changes before changing categories.</p>
           </div>

           
          <div *ngIf="showModalMobile" class="modal2">
            <p>Simple Mode not available for this tool</p>
          </div>

            <div *ngIf="valueLimitProjects" class="modal2">
            <p>You have reached your project limit (10).</p>
          </div>

                <div *ngIf="valueLimitProfileUsers" class="modal">
              <p>You have reached your user limit (10).</p>
          </div>

              <div *ngIf="valueMessageProfileOrg" style="color: #EE1A1A; text-align: center;" class="modal">
                <p>{{messageProfileOrg}}</p>
            </div>


            <!-- MODAL API-->
          <div class="modal-backdrop" *ngIf="showPaymentModal">
            <div class="payment-modal">

              <button class="close-btn" (click)="closeModalApi()">✕</button>

              <div class="icon">
                <img class="icon-success" src="./assets/images/successful-icon.svg">
              </div>

              <h2 class="payment_title">- Payment Successful -</h2>

              <p class="payment_subtitle">
                Thank you for subscribing to Text Inspector API.<br />
                You can now access all the exclusive benefits and features.
              </p>
              <br>
              <br>
              <div class="actions">
                <button class="btn-success primary" (click)="goToDocs()">View API Docs</button>
                <button class="btn-success secondary" (click)="goToAccount()">Go To My Account</button>
              </div>

            </div>
          </div>

          <!-- <div *ngIf="noProyectModal && isLogin" class="modal-export" style=" border: 1px solid #EE1A1A;">
            <div class="line" style="background-color: #EE1A1A;" ></div>
            <p>Project No Loaded</p>
          </div>

          <div *ngIf="loadProyectModal && isLogin" class="modal-export" style="border: 1px solid #217525;">
            <div class="line" style="background-color: #217525;"></div>
            <p>Project Loaded</p>
          </div> -->
          
          <ng-container *ngIf="selectedMenuItem === 'dashboard'">
            <div class="full-panel">
              <dashboard></dashboard>
              <br>
              <br>
              <br>
            </div>
          </ng-container>
          <ng-container *ngIf="(selectedMenuItem !== 'dashboard') && (selectedMenuItem === 'profile') ">
            <div class="full-screen-profile">
              <profile></profile>
              <br>
              <br>
              <br>
            </div>
          </ng-container>
          <ng-container *ngIf="(selectedMenuItem !== 'dashboard') && (selectedMenuItem === 'apiplan') ">
            <div class="full-screen-profile">
              <api-update></api-update>
              <br>
              <br>
              <br>
            </div>
          </ng-container>
          
          <ng-container *ngIf="(selectedMenuItem !== 'dashboard') && (selectedMenuItem !== 'profile') && (selectedMenuItem !== 'apiplan')">
            <div class="div_tabs_content"
              (click)="toggleLeftPanel()" (click)="toggleExpand('TEXT')" [ngClass]="{'expanded': isExpanded['TEXT']}">
              <span class="main-box-title-24" style="padding-left: 7px; font-size: 24px;">Text</span>
              <div style="width: 100%;"></div>
              <mat-icon  class="expand-icon">expand_more</mat-icon>
            </div>

            <div *ngIf="showLeftPanel" class="left-panel">
              <div *ngIf="isLogin" ><text-box [disabled]="isTextBoxDisabled" [textInputDisabled]="isTextInputDisabled" [checked]="checked"
                (checkedChange)="onCheckedChange($event)"></text-box></div>
              
                <div *ngIf="!isLogin" ><text-box-free [disabled]="isTextBoxDisabled" [textInputDisabled]="isTextInputDisabled" [checked]="checked"
                  (checkedChange)="onCheckedChange($event)"></text-box-free></div>
            </div>


          

            <div
              style="width:auto ;height: 5px;align-items: center; padding-left: 10px;  padding-right: 12px; margin-top: 10px;">
              <div style="width:auto ;height: .5px; background-color: #73767D;  "></div>
            </div>



            <div class="div_tabs_content"
              (click)="toggleRightPanel()" (click)="toggleExpand('RESULTS')" [ngClass]="{'expanded': isExpanded['RESULTS']}">
              <span class="main-box-title-24" style="padding-left: 7px; font-size: 24px;">Results</span>
              <div style="width: 100%;"></div>
              <mat-icon class="expand-icon" >expand_more</mat-icon>
            </div>
            <div *ngIf="showRightPanel" class="right-panel">


              <ng-container *ngIf="selectedMenuItem === 'summary'">
                <summary (menuItemSelected)="selectMenuItem($event)"></summary>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'statistics'">
                <statistics [checked]="checked"></statistics>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'readability'">
                <readability></readability>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'errors'">
                <errors></errors>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'lexicalDiversity'">
                <lexical-diversity></lexical-diversity>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'tagger'">
                <tagger [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></tagger>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'kvl'">
                <kvl [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></kvl>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'evp'">
                <evp [checked]="checked"></evp>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'coca'">
                <coca [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></coca>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'awl'">
                <awl [checked]="checked"></awl>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'metadiscourse'">
                <metadiscourse></metadiscourse>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'scorecard'">
                <scorecard></scorecard>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'summaryfree'">
                <summary-free (menuItemSelected)="selectMenuItem($event)"></summary-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'statisticsfree'">
                <statistics-free></statistics-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'readabilityfree'">
                <readability-free></readability-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'errorsfree'">
                <errors-free></errors-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'lexicalfree'">
                <lexical-free></lexical-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'taggerfree'">
                <tagger-free [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></tagger-free>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'evpfree'">
                <evp-free></evp-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'kvlfree'">
                <kvl-free [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></kvl-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'cocafree'">
                <coca-free [checked]="checked" (textItemSelected)="ontextItemSelected($event)"></coca-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'awlfree'">
                <awl-free></awl-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'metadiscoursefree'">
                <metadiscourse-free></metadiscourse-free>
                <br>
                <br>
                <br>
              </ng-container>
              <ng-container *ngIf="selectedMenuItem === 'scorecardfree'">
                <scorecard-free></scorecard-free>
                <br>
                <br>
                <br>
              </ng-container>

            </div>
            <div
              style="width:auto ;height: 5px;align-items: center; padding-left: 10px;  padding-right: 12px; margin-top: 10px;">
              <div style="width:auto ;height: .5px; background-color: #73767D;  "></div>
            </div>
            <div *ngIf="!showRightPanel">
              <br>
              <br>
            </div>
          </ng-container>
        </ng-container>
      </div>

    </mat-sidenav-content>
    

  </mat-sidenav-container>
</ng-template>
</ng-template>
</ng-container>

<div class="konami-backdrop" *ngIf="showKonamiThanks" (click)="closeKonamiThanks()">
  <div class="konami-panel" (click)="$event.stopPropagation()">
    <button type="button" class="konami-close" aria-label="Close" (click)="closeKonamiThanks()">x</button>
    <div class="konami-kicker">Text Inspector</div>
    <h2>Thank you</h2>
    <p>
      Special thanks to Esteban for his support in the creation of this app.
    </p>
    <p class="konami-signature">Your help made this work possible.</p>
  </div>
</div>
